import Record from 'services/api/record.ts'

export interface ButtonTypeMapping {
	color: string
	icon: string
	text: string
	dataTest: string
}

/**
 * Farbvergabe nach der „Earned Color Rule" aus DESIGN.md: Eine nicht-neutrale
 * Farbe muss Bedeutung tragen (Schweregrad, Status, Kategorie). Sie darf nicht
 * bloss der Unterscheidung dienen.
 *
 * Vorher standen hier fuenfmal `info` und einmal `success` fuer Aktionen ohne
 * jede Semantik. Das Ergebnis war eine Werkzeugleiste mit drei verschieden
 * gefaerbten Knoepfen nebeneinander (rot, gruen, blau), von denen keiner etwas
 * bedeutete — fuer rot-gruen-blinde Nutzer waren zwei davon derselbe Knopf.
 * Gleichzeitig trainiert das die Bedeutung weg, auf die die Sync-Fehler-Ansicht
 * angewiesen ist, wo `error`/`warning`/`success` echte Schweregrade sind.
 *
 * Die Regel jetzt:
 * - `primary` — die eine primaere Aktion eines Kontexts (Anlegen, Speichern).
 *   Traegt die Mandantenfarbe.
 * - `error` — ausschliesslich echt destruktiv (Loeschen).
 * - leer — alles andere. Ohne `color` vergibt Vuetify keine `bg-*`-Klasse, und
 *   die Knoepfe laufen auf der getoenten Struktur-Stufe aus App.vue mit. Damit
 *   folgen sie automatisch dem Mandanten-Theme, statt eine feste Farbe zu
 *   setzen.
 *
 * `cancel` stand auf `error`: Abbrechen ist kein Fehler und nichts
 * Destruktives, sondern der Ausgang. Rot war dort schlicht falsch.
 */
export const typeMapping: Record<string, ButtonTypeMapping> = {
	return: {
		color: '',
		icon: 'common.return.icon',
		text: 'common.return.name',
	},
	releaseNote: {
		color: 'primary',
		icon: 'common.releaseNote.icon',
		text: 'common.releaseNote.name',
		dataTest: 'link-btn',
	},
	add: {
		color: 'primary',
		icon: 'common.add.icon',
		text: 'common.add.name',
		dataTest: 'add-btn',
	},
	save: {
		color: 'primary',
		icon: 'common.save.icon',
		text: 'common.save.name',
		dataTest: 'save-btn',
	},
	cancel: {
		color: '',
		icon: 'common.cancel.icon',
		text: 'common.cancel.name',
		dataTest: 'cancel-btn',
	},
	close: {
		color: '',
		icon: 'common.close.icon',
		text: 'common.close.name',
		dataTest: 'close-btn',
	},
	delete: {
		color: 'error',
		icon: 'common.delete.icon',
		text: 'common.delete.name',
		dataTest: 'delete-btn',
	},
	update: {
		color: '',
		icon: 'common.update.icon',
		text: 'common.update.name',
		dataTest: 'update-btn',
	},
	reload: {
		color: '',
		icon: 'common.reload.icon',
		text: 'common.reload.name',
		dataTest: 'reload-btn',
	},
	setting: {
		color: '',
		icon: 'common.settings.icon',
		text: 'common.settings.name',
		dataTest: 'setting-btn',
	},
}
